export const isSameLanguage = (l1: string, l2: string): boolean => {
  if (!l1 || !l2) {
    return false;
  }

  return l1.toLowerCase() === l2.toLowerCase();
};

export const formatLocale = (locale: string): string => {
  const localeSplit = locale.split('_');

  if (localeSplit.length === 1) {
    return locale;
  }

  return `${localeSplit[0].toLowerCase()}_${localeSplit[1].toUpperCase()}`;
};

export const getValidLanguage = (locale: string): string => {
  const validLanguage = locale !== 'uk_UK' && locale !== 'UKRA' ? locale : 'en_US';
  return validLanguage;
};
